import { UpdatePickTourPayload } from '../actions/activePickTour.types';
import { APIPickTour, UpdatePickTourRequest } from './types';

export const mapPickTourDataToUpdatePickTourRequest = (
  payload: UpdatePickTourPayload,
  pickTourData: APIPickTour
): UpdatePickTourRequest => {
  const skipItemsAction = payload.skipItemsAction || '';
  return {
    ...pickTourData,
    pickTourList: [],
    pickTourStatus: payload.updateStatus.pickTourStatus,
    pickTourSubStatus: payload.updateStatus.pickTourSubStatus,
    metadata: {
      ...pickTourData.metadata,
      skipItemsAction,
    },
  };
};
